export default __webpack_public_path__ + "static/white-black-cork-752ed506c8654d12f00bb66b279c1544.png";